<template>
  <span>
    <component
      :is="button"
      v-b-modal="id"
    >{{textTitle}}
    </component>
    <b-modal
      v-bind="$attrs"
      :id="id"
      :title="textTitle"
      ok-only
      static
    >
      <div class="hide-title">
        <slot/>
      </div>
    </b-modal>
  </span>
</template>

<script>
import { get, uniqueId } from 'lodash'

import HelpButton from '@/components/HelpButton.vue'
import InfoButton from '@/components/InfoButton.vue'

export default {
  name: 'HelpModal',
  components: {
    HelpButton,
    InfoButton,
  },
  inheritAttrs: false,
  props: {
    button: {
      type: String,
      default: 'HelpButton'
    },
  },
  data() {
    return {
      textTitle: null,
      id: null,
    }
  },
  created() {
    this.id = uniqueId('help_')
  },
  mounted() {
    this.textTitle = getTitle(this.$slots.default)
  },
}

function getTitle(slot) {
  return get(slot, '[0]elm.children[0].textContent')
}
</script>

<style lang="scss" scoped>
/deep/ .hide-title > * > *:first-child {
  display: none;
}
</style>
